import { Mail } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { DropdownSection, SectionTitle, useDropdownSectionState } from '../../Common/Layout';
import { SentMessage } from '../helpers';
import UI from '../../../common/UI';
import useLocale from '../../../common/useLocale';

export interface MessagesSectionProps {
  messages: SentMessage[];
}

const MessagesSection = ({ messages }: MessagesSectionProps) => {
  const { t } = useTranslation();
  const { formatDate, parseDate } = useLocale();
  const { isOpen, toggleSection } = useDropdownSectionState();

  return (
    <UI.GridContainer sc={{ gutter: 0.75 }}>
      <UI.Div>
        <SectionTitle count={messages.length}>
          {t('messages')}
        </SectionTitle>
      </UI.Div>

      <UI.GridContainer sc={{ gutter: 1 / 3 }}>
        {messages.map((sentMessage) => (
          <DropdownSection
            open={isOpen(sentMessage.id)}
            onToggle={() => toggleSection(sentMessage.id)}
            title={sentMessage.message.subject}
            preview={(
              <>
                <UI.H4>
                  <UI.Icon sc={{ color: 'gray.500', mr: 1.5 }}>
                    <Mail />
                  </UI.Icon>
                  {sentMessage.message.subject}
                </UI.H4>
                <UI.Div sc={{ muted: true }}>
                  {sentMessage.sent_at && formatDate(
                    parseDate(sentMessage.sent_at, { timezone: 'UTC' }),
                    { format: 'display_date' },
                  )}
                </UI.Div>
              </>
            )}
            body={(
              <UI.Div sc={{ padding: [3, 4] }}>
                <UI.HTML html={sentMessage.message.parsed_content} />
              </UI.Div>
            )}
            key={sentMessage.message.id}
          />
        ))}
      </UI.GridContainer>
    </UI.GridContainer>
  );
};

export default MessagesSection;
